import React from 'react';
import { Layout, Dropdown, Space, Avatar, Button, Drawer } from 'antd';
import { UserOutlined, MenuOutlined, LogoutOutlined, SwapOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Header } = Layout;

const AppHeader = ({ 
  isMobile, 
  formMeta, 
  userMenuItems, 
  drawerVisible, 
  setDrawerVisible, 
  handleLogout, 
  user,
  showReassignButton = false,
  onReassignClick
}) => {
  const navigate = useNavigate();
  
  return (
    <>
      <Header
        style={{
          background: '#fff',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingLeft: isMobile ? 16 : 24,
          paddingRight: isMobile ? 16 : 24,
          position: 'sticky',
          top: 0,
          zIndex: 100,
          height: 'auto',
          minHeight: 64
        }}
      >
        <div style={{ 
          fontSize: isMobile ? 16 : 18, 
          fontWeight: 600,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: 1
        }}>
          {formMeta.image?.[0]?.public_url && (
            <img
              src={formMeta.image[0].public_url}
                alt="Form Logo"
                style={{
                  width: 32,
                  height: 32,
                  objectFit: 'cover',
                  borderRadius: 6,
                  marginRight: 12,
                  verticalAlign: 'middle'
                }}
            />
          )}
          {formMeta.name || 'Site Visit Form'}
        </div>

        {!isMobile ? (
          <Space>
            {showReassignButton && (
              <Button
                type="default"
                icon={<SwapOutlined />}
                onClick={onReassignClick}
                style={{
                  borderColor: '#5568d3',
                  color: '#5568d3',
                  marginRight: 12
                }}
              >
                Reassign Lead
              </Button>
            )}
            <Dropdown menu={{ items: userMenuItems }} trigger={['click']}>
              <Space style={{ cursor: 'pointer' }}>
                <Avatar
                  size="large"
                  icon={<UserOutlined />}
                  style={{ backgroundColor: '#1976d2' }}
                />
              </Space>
            </Dropdown>
          </Space>
        ) : (
          <Space>
            {showReassignButton && (
              <Button
                type="default"
                icon={<SwapOutlined />}
                onClick={onReassignClick}
                size="small"
                style={{
                  borderColor: '#5568d3',
                  color: '#5568d3'
                }}
              />
            )}
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setDrawerVisible(true)}
              style={{ marginLeft: 8 }}
            />
          </Space>
        )}
      </Header>

      {isMobile && (
        <Drawer
          title="Menu"
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          placement="right"
        >
          <div style={{ marginBottom: 20, textAlign: 'center' }}>
            <Avatar
              size={64}
              icon={<UserOutlined />}
              style={{ backgroundColor: '#1976d2', marginBottom: 12 }}
            />
            {user && (
              <div>
                <div style={{ fontSize: 16, fontWeight: 500, color: '#333', marginBottom: 4 }}>
                  {user.name || user.email || 'User'}
                </div>
                {user.admin_access && (
                  <div style={{ fontSize: 12, color: '#1976d2' }}>
                    Admin Access
                  </div>
                )}
              </div>
            )}
          </div>

          {showReassignButton && (
            <Button
              type="default"
              icon={<SwapOutlined />}
              block
              onClick={() => {
                onReassignClick();
                setDrawerVisible(false);
              }}
              style={{ 
                textAlign: 'left', 
                marginBottom: 8,
                borderColor: '#5568d3',
                color: '#5568d3'
              }}
            >
              Reassign Lead
            </Button>
          )}

          <Button
            type="text"
            icon={<UserOutlined />}
            block
            onClick={() => {
              navigate('/');
              setDrawerVisible(false);
            }}
            style={{ textAlign: 'left', marginBottom: 8 }}
          >
            Profile
          </Button>
          <Button
            type="text"
            icon={<LogoutOutlined />}
            block
            danger
            onClick={handleLogout}
            style={{ textAlign: 'left' }}
          >
            Logout
          </Button>
        </Drawer>
      )}
    </>
  );
};

export default AppHeader;